<template>
  <div>
    <b-overlay
      :show="showSpinner" 
      rounded="sm"
    >
      <b-card title="Admin Panel">
        <b-row>
          <b-col cols="3">
            <div class="position-relative">
              <label for="dateSearch">Date</label>
              <b-form-datepicker
                id="dateSearch"
                v-model="dateSearch"
                @input="debounceSearch"
                placeholder="Choose a date"
                locale="en"
                today-button
                reset-button
                close-button
              />
            </div>
          </b-col>
          <b-col cols="6">
            <label for="typeData">Type</label>
            <v-select
              id="typeData"
              v-model="selectedTypeData"
              :options="typeDataOption"
              label="text"
              :reduce="option => option.value"
              :clearable="false"
              @input="fetchData"
            />
          </b-col>
          <b-col cols="3">
            <div class="position-relative">
              <label for="textSearch">Search</label>
              <b-form-input
                id="textSearch"
                v-model="search"
                @input="debounceSearch"
                type="text"
                placeholder="Type to Search"
              />
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div style="overflow-x: visible;">
                    <b-table
                      hover
                      responsive
                      head-variant="dark"
                      small
                      outlined
                      :items="dataTable"
                      :fields="headers"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :stacked="stackedStatus"
                      show-empty
                    >
                    <template v-slot:cell(props)="row">
                      {{formatType(row.value.type)}}
                    </template>
                    <template v-slot:cell(picklistNumber)="row">
                      {{row.item.picklistNo && row.item.picklistLine ? `${row.item.picklistNo}_${row.item.picklistLine}` : ''}}
                    </template>
                    <template v-slot:cell(lineItemDescription)="row">
                      {{row.item.lineItem && row.item.lineDescription ? `${row.item.lineItem}, ${row.item.lineDescription}` : ''}}
                    </template>
                    <template v-slot:cell(pauseTimestamp)="row">
                      {{row.value ? new Date(row.value).toLocaleString() : '' }}
                    </template>
                    <template v-slot:cell(pauseInterval)="row">
                      {{row.value + ' minute' }}
                    </template>
                    <template v-slot:cell(restartTimestamp)="row">
                      {{row.value ? new Date(row.value).toLocaleString() : '' }}
                    </template>
                    <template v-slot:cell(actions)="row">
                      <b-dropdown variant="success" size="sm" text="Menu" no-caret>
                        <template #button-content>
                          <feather-icon size="1x" icon="MenuIcon"/>
                        </template>
                        <b-dropdown-item>
                          <b-button
                            variant="primary"
                            size="sm"
                            :to="{ name: goToEditPath(), params: { id: row.item.id } }"
                            style="margin-right: 10px;">
                            <feather-icon size="1x" icon="EditIcon"
                          />
                          </b-button>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="2">
                  <b-form-group
                    label="Data Per Page"
                    label-for="per-page-select"
                    label-cols-md="0"
                    label-align-sm="left"
                    label-size="md"
                    class="mb-0"
                  >
                    <v-select
                      class="select-sm"
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      :clearable="false"
                      @input="fetchData()"
                    />
                  </b-form-group>
                </b-col>
                <b-col class="pt-2">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    @change="onPageChange"
                    :total-rows="totalRows"
                    first-number
                    last-number
                    class="float-right"
                    aria-controls="user-table"
                  ></b-pagination>
                </b-col>
              </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedTypeData: "job_order",
      typeDataOption: [
        { text: "Job Order", value: "job_order" },
        { text: "Picklist", value: "picklist" },
        { text: "Pause Job", value: "pause_job" }
      ],
      search: "",
      dateSearch: null,
      showSpinner: false,
      dataTabel: [
        { id: 1, name: "Order 1", status: "Active" },
        { id: 2, name: "Order 2", status: "Paused" }
      ],
      jobOrderHeaders: [
        { key: 'orderNumber', label: 'Order Number', sortable: true },
        { key: 'drumID', label:"From Batch"},
        { key: 'props', label:"Type"},
        { key: 'actions', label: 'Actions' }
      ],
      picklistHeaders: [
        { key: 'orderNumber', label: 'SO Number', sortable: true },
        { key: 'picklistNumber', label:"Picklist Number"},
        { key: 'lineItemDescription', label:"Line Item Description"},
        { key: 'quantity', label:"Quantity"},
        { key: 'unit', label:"Unit"},
        { key: 'fromBatch', label:"From Batch"},
        { key: 'toBatch', label:"To Batch"},
        { key: 'cuttingNumber', label:"Cutting Number"},
        { key: 'remark', label:"Remark"},
        { key: 'actions', label: 'Actions' }
      ],
      pauseJobHeaders: [
        { key: 'user.username', label: 'Username', sortable: true },
        { key: 'user.email', label:"Email"},
        { key: 'pauseTimestamp', label:"Pause Time"},
        { key: 'pauseInterval', label:"Interval Time"},
        { key: 'restartTimestamp', label:"Restart Time"},
        { key: 'actions', label: 'Actions' }
      ],
      sortBy: 'id',
      sortDesc: false,
      stackedStatus: false,
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      currentPage: 1,
      totalRows: 2
    }
  },
  computed: {
    headers() {
      if (this.selectedTypeData === 'job_order') {
        return this.jobOrderHeaders;
      } else if (this.selectedTypeData === 'picklist') {
        return this.picklistHeaders;
      } else if (this.selectedTypeData === 'pause_job') {
        return this.pauseJobHeaders;
      }
    },
    dataTable() {
      return this.$store.getters['admin/getData']
    }

  },
  methods: {
    debounceSearch(event) {
      this.showSpinner = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.showSpinner = false;
        this.fetchData()
      }, 600);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    fetchData() {
      this.showSpinner = true;
      const payload = {
        type: this.selectedTypeData,
        search: this.search,
        page: this.currentPage,
        entry: this.perPage,
        dateSearch: this.dateSearch ? this.dateSearch : undefined
      }
      this.$store.dispatch("admin/getItems", payload)
      .then((res) => {
        this.showSpinner = false;
        // this.totalRows = res.totalData
        this.totalRows = res.totalData || 1
      })
      .catch(err => {
        this.showSpinner = false;

        console.error(err)
        this.$bvToast.toast("Error get data", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      })
    },
    formatType(type) {
      switch (type) {
        case 'Cutting':
          return "Cutting - 剪线"
        case 'Direct Sale':
          return "Direct Sale - 直销"
        case "Recoil":
          return "Recoil - 卷线换轴"
        case "Direct Short Length":
          return "Direct Short Length - 剪短线"
        default:
          return type
      }
    },
    goToEditPath() {
      switch (this.selectedTypeData) {
        case 'job_order':
          return 'update-job-order'
        case 'picklist':
          return 'update-picklist'
        case 'pause_job':
          return 'update-pause-job'
        default:
          return 'data-manager'
      }
    }
  },
  mounted() {
    if (this.$session && this.$session.has("perPageAdminPanel")) {
      this.perPage = this.$session.get("perPageAdminPanel");
    }
    this.fetchData();
  },
  watch: {
    perPage(perPageNew) {
      if (this.$session) {
        this.$session.set("perPageAdminPanel", perPageNew);
      }
    }
  },
}
</script>

<style>
.vs__dropdown-toggle {
  min-height: 40px; /* default sekitar 36px */
}

.select-sm .vs__dropdown-toggle {
  min-height: 30px; /* default sekitar 36px */
}
</style>